import { getDefaultOptions as t } from "./_lib/defaultOptions.js";
function a() {
  return Object.assign({}, t());
}
export {
  a as default,
  a as getDefaultOptions
};
//# sourceMappingURL=getDefaultOptions.js.map
